import { DataCardsButtonProps } from 'site/Renderer/components/DataCards/DataCards.types'
import { StatusAction } from 'status/shared/situation.type'

export type SyntheticActionOption = {
  children: string
  onClick: () => void
}

type BuildSyntheticActionOptionsParams = {
  isWaitingInteraction: boolean
  buttonProps?: DataCardsButtonProps
  executeLabel: string
  executeHref: string
  viewLabel: string
  displayedStatusActions: StatusAction[]
  changeStatus: (statusUuid: string) => void
  outputTaskVisualizeHref?: string
}

export default function buildSyntheticActionOptions({
  isWaitingInteraction,
  buttonProps,
  executeLabel,
  executeHref,
  viewLabel,
  displayedStatusActions,
  changeStatus,
  outputTaskVisualizeHref
}: BuildSyntheticActionOptionsParams): SyntheticActionOption[] {
  const options: SyntheticActionOption[] = []

  if (isWaitingInteraction) {
    options.push({
      children:
        buttonProps !== undefined && 'label' in buttonProps && buttonProps.label
          ? String(buttonProps.label)
          : executeLabel,
      onClick: () => {
        window.location.assign(executeHref)
      }
    })
  }

  displayedStatusActions.forEach((statusAction) => {
    options.push({
      children: statusAction.des,
      onClick: () => changeStatus(statusAction.destination_status[0].code)
    })
  })

  if (outputTaskVisualizeHref) {
    options.push({
      children: viewLabel,
      onClick: () => {
        window.open(outputTaskVisualizeHref, '_blank', 'noopener,noreferrer')
      }
    })
  }

  return options
}
